import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { capitalize, get, set, startCase } from 'lodash';
import { connect } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { CLIENT_TYPE } from '@upstart/harmony/lib/constants';
import { withRouter } from 'react-router-dom';
import DealerNav from '../../components/DealerNav';
import SidebarContainer from '../SidebarContainer';
import * as dealersActions from '../../redux/dealers/actions';
import * as translationsActions from '../../redux/translations/actions';
import './DealerTextEditor.scss';

const LANGUAGE_LIST = ['en-US', 'es-MX'];
const COMMON_STRING_LIST = ['disclaimer'];

function DealerTextEditor({
  actions,
  dealer,
  match,
  history,
  fetching,
  translations,
}) {
  // Only support Online for now
  const clientType = CLIENT_TYPE.ONLINE;
  const { pageId, dealerId } = match.params;

  useEffect(() => {
    actions.dealerRequest({ dealerId });
    actions.translationRequest({ dealerId });
  }, [actions, dealerId]);

  return (
    <SidebarContainer title={dealer.name} logo={dealer.logo}>
      <div className="dealers-table">
        <DealerNav />
        <div className="dealer-editor-container">
          {fetching && (
            <Dimmer active inverted>
              <Loader inverted content="Loading" />
            </Dimmer>
          )}
          <div className="dealer-text-header">
            <h3>
              {capitalize(clientType)}: {startCase(pageId)}
            </h3>
            <button className="btn btn-default" onClick={history.goBack}>
              Back
            </button>
          </div>
          {COMMON_STRING_LIST.map((val) => (
            <div key={val} className="dealer-text-value-container">
              <div className="dealer-text-value-header">{startCase(val)}</div>
              {LANGUAGE_LIST.map((lang) => {
                const translationKey = `${clientType}.${lang}.${pageId}.${val}`;

                return (
                  <div key={lang} className="dealer-text-input-container">
                    <span className="dealer-text-input-label">{lang}</span>{' '}
                    <textarea
                      className="form-control"
                      onChange={(e) => {
                        const updatedTranslations = { ...translations };
                        set(
                          updatedTranslations,
                          translationKey,
                          e.target.value,
                        );
                        actions.setTranslation(updatedTranslations);
                      }}
                      value={get(translations, translationKey, '')}
                    />
                  </div>
                );
              })}
            </div>
          ))}
          <div>
            <button className="btn btn-default" onClick={history.goBack}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() =>
                actions.translationUpdateRequest({ dealerId, translations })
              }
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </SidebarContainer>
  );
}

DealerTextEditor.propTypes = {
  actions: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object,
  fetching: PropTypes.bool,
  translations: PropTypes.object,
};

const mapStateToProps = ({ dealers, translations }) => ({
  dealer: dealers.dealer,
  translations: translations.data,
  fetching: dealers.fetching || translations.fetching,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    { ...dealersActions, ...translationsActions },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DealerTextEditor),
);
